import React from "react"
import { Position, Tooltip } from "@blueprintjs/core"
import Schema from "../details/validation"
import { getColumnSize } from "modules/common/services/table/size-storage"
import { getFieldLabel } from "modules/common/services/form/fields"
import { fields } from "../../models/project-portfolio"
import { ColDef } from "ag-grid-community";
import { RowNumberColumn } from "modules/common/services/table/helpers"
import { GeneralIcon } from "modules/common/components/planr/icon/Generalcon"

const schema = Schema()

export const columns = (tableName: string) => {
    const columnSize = getColumnSize(tableName)

    const result: ColDef[] = [
        RowNumberColumn(false, ""),
        {
            // отметка организации, которой принадлежит счёт на оплату по умолчанию
            headerName: "",
            field: fields.hasMainBankDetails,
            width: columnSize(fields.hasMainBankDetails, 36),
            sortable: false,
            resizable: false,
            cellRenderer: ({ data }: any) =>
                data && data.hasMainBankDetails ? (
                    <Tooltip
                        content={`Счёт на оплату по умолчанию: ${data.mainBankDetailsName ?? ""}`}
                        position={Position.RIGHT}
                    >
                        <GeneralIcon type="general-star-fill" size={12} style={{ color: "#ea561e" }} />
                    </Tooltip>
                ) : null,
        },
        {
            headerName: getFieldLabel(fields.name, schema, null),
            field: fields.name,
            width: columnSize(fields.name, 300),
            sortable: true,
            resizable: true,
        },
        {
            headerName: getFieldLabel(fields.director, schema, null),
            field: fields.director,
            width: columnSize(fields.director, 250),
            sortable: false,
            resizable: true,
            cellRenderer: (data: any) => {
                if (data.data.director !== null) {
                    return data.data.director.name
                }
                return null
            },
        },
        {
            headerName: getFieldLabel(fields.description, schema, null),
            field: fields.description,
            width: columnSize(fields.description, 700),
            sortable: false,
            resizable: true,
        },

    ]

    return result
}
